export default "__VITE_ASSET__j7MNKKSP__"